<template>
    <modal v-if="isOpen" class-name="widget-modal" @close="$emit('close')">
        <template #body>
        <div>
            <Configurator />
        </div>
        </template>
    </modal>
</template>

<script>
    import Modal from '../common/Modal';
    import Configurator from "../Configurator";
    
    export default {
      components: {
        Modal,
        Configurator
      },
      props: ['isOpen']
    };
</script>


// WEBPACK FOOTER //
// src/components/modals/WidgetModal.vue